import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'

import {
  Select as SelectComponent,
  DialogLayout,
  LoadingBox,
  CompanyTypeAndSeachInput,
} from 'components'

import { useSnackbar } from 'hooks'

import * as service from 'service'
import helpers from 'helpers'
import theme from 'theme'
import constants from 'constants/index'

import schema from './schema'

const UserCompaniesForm = ({
  userId = '',
  setOpen,
  open,
  refresh = () => {},
  currentUserCompany,
  isEdit = false,
}) => {
  const [company, setCompany] = useState()
  const [profiles, setProfiles] = useState([])
  const [isLoadingProfile, setIsLoadingProfile] = useState(false)

  const snackbar = useSnackbar()
  const { control, handleSubmit, errors, setValue } = useForm({
    validationSchema: schema(isEdit),
    defaultValues: {
      companyId: currentUserCompany?.company || null,
      profileId: currentUserCompany?.profile?.id || '',
    },
  })

  const { KIND_SUPPLIER } = constants.companies

  const onSubmit = async (data) => {
    try {
      if (isEdit) {
        await service.dponet.userCompanies.put({
          id: currentUserCompany?.id,
          profileId: data.profileId,
        })
      } else {
        await service.dponet.userCompanies.vinculateUserCompany({
          userId,
          companyId: data.companyId.id,
          userCompany: {
            profileId: data.profileId,
          },
        })
      }

      snackbar.open({
        message: isEdit
          ? `Perfil do usuário na empresa alterado!`
          : `Usuário vinculado a empresa ${data.companyId.name}`,
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setOpen(false)
    }
  }

  const handleChangeCompany = () => {
    setValue('profileId', '')
  }

  useEffect(() => {
    const loadProfiles = async () => {
      if (!company && !currentUserCompany) return

      if (
        [currentUserCompany?.company?.kind, company?.kind].includes(
          KIND_SUPPLIER,
        )
      ) {
        setProfiles(constants.profile.SUPPLIER_PROFILE_OPTIONS)

        return
      }

      setIsLoadingProfile(true)

      const response = await service.backoffice.userProfiles.get({
        perPage: 100000,
        companyId: company?.id || currentUserCompany?.company?.id,
        listDefaults: true,
        status: true,
      })

      setProfiles(response?.data?.profiles)
      setIsLoadingProfile(false)
    }

    loadProfiles()
    // eslint-disable-next-line
  }, [company, currentUserCompany])

  return (
    <DialogLayout
      title={
        isEdit
          ? 'Editar vínculo de empresa e usuário'
          : 'Vincular empresa ao usuário'
      }
      open={open}
      setOpen={setOpen}
      confirmTextButton="Salvar"
      handleSubmit={handleSubmit(onSubmit)}
    >
      <Box
        width={500}
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
      >
        {!isEdit && (
          <CompanyTypeAndSeachInput
            setCompanyId={setCompany}
            handleChangeCompany={handleChangeCompany}
            control={control}
            errors={errors}
            fullData={true}
          />
        )}
        {!isLoadingProfile ? (
          <Controller
            control={control}
            name="profileId"
            mode="onChange"
            as={
              <SelectComponent
                disabled={!company && !isEdit}
                label="Perfil de usuário"
                items={profiles || []}
                error={!!errors.profileId}
                loading={isLoadingProfile}
                helperText={errors?.profileId?.message}
              />
            }
          />
        ) : (
          <LoadingBox />
        )}
      </Box>
    </DialogLayout>
  )
}

UserCompaniesForm.propTypes = {
  userId: PropTypes.number,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  refresh: PropTypes.func,
  isEdit: PropTypes.bool,
  currentUserCompany: PropTypes.object,
}

export default UserCompaniesForm
